import React, { useEffect, useState } from "react";
import backendurl from "./backendapiConfig";
import { Link, useNavigate } from 'react-router-dom';
import { RotateSpinner } from "react-spinners-kit";
import { BASE_URL } from './apiConfig';
import './CommonCSS.css'
export default function Navbar({ toggleSidebar }) {
    const [loading, setloading] = useState(false);
    const [creditcount, setcreditcount] = useState(0);
    const [apiData, setApiData] = useState([]);
    const [isDownloadOpen, setIsDownloadOpen] = useState(false);

    const navigate = useNavigate();

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;

    const handleClick = () => {
        navigate('/downloadcenter');
        document.getElementById('closeModalButton').click();
    };

    const handleLogout = () => {
        sessionStorage.setItem('loginData', null);
        document.getElementById('closeModalButton1').click();
        navigate('/login');
    }

    const handledownloaddropdown = () => {
        setIsDownloadOpen(!isDownloadOpen);
        callApi("5");
    };

    const callApi = async (str) => {
       
        setloading(true);
        const apiUrl = `${BASE_URL}/DownloadTable`;
        const requestBody = {
            Haslimit: str,
            guiuserid: sessionusername,
            utype:{
                usertype:sessionusertype
            }
        };
        const fetchOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },

            body: JSON.stringify(requestBody),
        };

        try {
            const response = await fetch(apiUrl, fetchOptions);
            setloading(false);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            setApiData(data);
            // Callback to the parent component
        } catch (error) {
            console.error("API Request Error:", error.message);
            setloading(false);
        }
    };

     const callcreditAPI = async () => {
        const sessionusername = sessionStorage.getItem("username");
        const apiUrl = `${BASE_URL}/Credit`;
        const urlWithParams = apiUrl + `?uid=${sessionusername}`;
        console.log("urlwithparam:" + urlWithParams);
        const fetchOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        };
    
        try {
            const response = await fetch(urlWithParams, fetchOptions);
            const data = await response.json();
            if (data?.errorCode === "200"){
                setcreditcount(data?.creditcount);
            }
        } catch (error) {
            console.error(" Request Error:", error);
        }
    };

      useEffect(() => {
            callcreditAPI();
        }, []);
        
    const apiDataLength = apiData?.length;

    return (
        <div className="Navbar-container">
            <div style={{ display: "flex", width: "80%" }}>
                <div style={{ height: "100%", padding: "0rem 0.7rem", paddingTop: "1rem" }} className="ibar" onClick={toggleSidebar}>
                    <i class="fa-solid fa-bars " style={{ color: "white", fontSize: "1.5rem" }}></i>
                </div>
                <img src="images/logo-Vconnect.png" className="img-size" />
            </div>

            <div style={{ display: "flex" }}>
                <div className="credit-div" >
                    <span style={{ color: "white" }}>
                    </span>
                    <span className="Pending " style={{ marginRight: "0.2rem" }}>

                        <span className="myspancredit"><span className="myspancredit2">Available</span>  Credits:</span> {creditcount}</span>

                </div>

                <div className="download-div" style={{ position: "relative" }}>
                    <i className="fa fa-download" style={{ color: "white", cursor: "pointer", marginTop: "0.1rem" }} data-toggle="modal" data-target="#myModal" onClick={handledownloaddropdown}></i>
                    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                        <div class="modal-dialog custom-modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header" >
                                    <h5 class="modal-title" id="myModalLabel" >Recent Downloads</h5>

                                </div>
                                <div class="modal-body" style={{ padding: "0rem", position: "relative" }}>
                                    {loading === true ? <div style={{ width: "100%", height: "1rem", zIndex: "-1" }}>
                                        <div className="navbar-progress-spinner">
                                            <RotateSpinner color="black" />
                                        </div>
                                    </div> : <></>}
                                    <div className={loading === true ? "dropdown-main-content blurred" : "dropdown-main-content"}>
                                        {apiDataLength === 0 ? (
                                            <div>
                                                <div className="download-icon-div">
                                                    <i className="fa-solid fa-file-code"></i>
                                                </div>

                                                <div className="download-span-div">
                                                    <span>No Downloads !!!</span>
                                                </div>


                                            </div>
                                        ) : (
                                            <>
                                                <table
                                                    className="table table-bordered dom-jQuery-events table-responsive"
                                                    style={{ background: "black" }}
                                                >
                                                    <thead
                                                        style={{
                                                            backgroundColor: "rgb(67, 177, 221)",
                                                            fontSize: "1rem",
                                                        }}
                                                    >
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>Filename</th>
                                                            <th style={{ textAlign: "center" }}>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontSize: "1rem" }}>
                                                        {apiData?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ccc",
                                                                        padding: "1rem",
                                                                        verticalAlign: "middle",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {item?.fname}
                                                                </td>
                                                                <td style={{ display: "flex", alignItems: "center" }}>
                                                                    <span
                                                                        className={
                                                                            item?.fstatus === "In-Progress"
                                                                                ? "Pending"
                                                                                : "Success"
                                                                        }
                                                                    >
                                                                        {item?.fstatus}
                                                                    </span>
                                                                    {item?.fstatus === "In-Progress" ? (
                                                                        <span></span>
                                                                    ) : (
                                                                        <span style={{ marginLeft: "0.6rem" }}>
                                                                            <a
                                                                                href={backendurl + item?.durl}
                                                                                style={{ color: "white" }}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-download"
                                                                                    style={{ color: "white" }}
                                                                                ></i>
                                                                            </a>
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>


                                            </>
                                        )}
                                    </div>
                                </div>
                                <div class="modal-footer" style={{ fontSize: "1.1rem" }}>
                                    <span style={{ textDecoration: "none", color: "white" }} onClick={handleClick}> Download Center</span>
                                    <button id="closeModalButton" data-dismiss="modal" style={{ display: "none" }}></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="profile-div" style={{ position: "relative" }} >
                    <i className="fa-solid fa-user-tie" data-toggle="modal" data-target="#myModal1" ></i>
                    <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
                        <div class="modal-dialog custom-modal-dialog-1" role="document">
                            <div class="modal-content">
                                <div class="modal-body" style={{ padding: "0rem", position: "relative" }}>
                                    <Link to="/editprofile" style={{textDecoration:"none", color:"#fff"}} onClick={ document.getElementById("closeModalButton1")?.click()}>Edit Profile <span><i class="fa-regular fa-pen-to-square ml-2"></i></span> </Link>
                                    <p style={{marginTop:"0.5rem"}} onClick={handleLogout} >Logout <i class="fa-solid fa-right-from-bracket ml-2"></i> </p>
                                    <button id="closeModalButton1" data-dismiss="modal" style={{ display: "none" }}></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}